// extracted by mini-css-extract-plugin
export default {"profile-completion-nav-card":"style_profile-completion-nav-card__ZQpTE","profileCompletionNavCard":"style_profile-completion-nav-card__ZQpTE"};